import FileUpload from './FileUpload.vue'
import PhotoUpload from './PhotoUpload.vue'
import PhotoUploadCaram from './PhotoUploadCaram.vue'
import PersanCert from './PersanCert.vue'
import ImageView from './ImageView.vue'
import PhotoPreview from './PhotoPreview.vue'
import Group from './Group'
import Cell from './Cell'
import Dist from './Dist'
import Dict from './Dict'
import DateTime from './DateTime'
import Magnify from './Magnify.vue'
import CtrlAuth from './CtrlAuth'
import VueEcharts from './VueEcharts'
import TuboCell from './TuboCell'
import TuboCellGroup from './TuboCellGroup'


export {
  FileUpload,
  PhotoUpload,
  PhotoUploadCaram,
  PersanCert,
  ImageView,
  PhotoPreview,
  Group,
  Cell,
  Dist,
  Dict,
  DateTime,
  Magnify,
  CtrlAuth,
  VueEcharts,
  TuboCell,
  TuboCellGroup,
}
